import teamImg1 from '../assets/images/team/team-01.webp';
import teamImg2 from '../assets/images/team/team-02.webp';
import teamImg3 from '../assets/images/team/team-03.webp';
import teamImg4 from '../assets/images/team/team-04.webp';
import teamImg5 from '../assets/images/team/team-05.webp';
import teamImg6 from '../assets/images/team/team-06.webp';
import teamImg7 from '../assets/images/team/team-07.webp';
import teamImg8 from '../assets/images/team/team-08.webp';
import teamImg9 from '../assets/images/team/team-09.webp';
import teamImg10 from '../assets/images/team/team-10.webp';
import teamImg11 from '../assets/images/team/team-11.webp';
import teamImg12 from '../assets/images/team/team-12.webp';

const TeamList = [
  {
    id: 1,
    image: teamImg1,
    name: 'Aaron Sharp',
    position: 'Chief People Officer',
    email: 'info@example.com',
    phone: '+101 800 555 45',
    address: '2 Thorndale Circle, Magnolia,de, 19962  United States',
    social: [
      { id: 1, icon: 'fab fa-facebook-f', url: 'https://www.facebook.com' },
      { id: 2, icon: 'fab fa-twitter', url: 'https://twitter.com' },
      { id: 3, icon: 'fab fa-linkedin-in', url: 'https://in.linkedin.com' },
    ],
    blockquote:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit volup tatem acusantium dolor emque laud antium.',
  },
  {
    id: 2,
    image: teamImg2,
    name: 'Homer Reyes',
    position: 'Vice President',
    email: 'info@example.com',
    phone: '+101 800 555 45',
    address: '2 Thorndale Circle, Magnolia,de, 19962  United States',
    social: [
      { id: 1, icon: 'fab fa-facebook-f', url: 'https://www.facebook.com' },
      { id: 2, icon: 'fab fa-twitter', url: 'https://twitter.com' },
      { id: 3, icon: 'fab fa-linkedin-in', url: 'https://in.linkedin.com' },
      { id: 4, icon: 'fab fa-instagram', url: 'https://www.instagram.com' },
    ],
    blockquote:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit volup tatem acusantium dolor emque laud antium.',
  },
  {
    id: 3,
    image: teamImg3,
    name: 'Felica Queen',
    position: 'Team Leader',
    email: 'info@example.com',
    phone: '+101 800 555 45',
    address: '2 Thorndale Circle, Magnolia,de, 19962  United States',
    social: [
      { id: 1, icon: 'fab fa-facebook-f', url: 'https://www.facebook.com' },
      { id: 2, icon: 'fab fa-twitter', url: 'https://twitter.com' },
      { id: 3, icon: 'fab fa-linkedin-in', url: 'https://in.linkedin.com' },
    ],
    blockquote:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit volup tatem acusantium dolor emque laud antium.',
  },
  {
    id: 4,
    image: teamImg4,
    name: 'Sara Lisbon',
    position: 'Production Manager',
    email: 'info@example.com',
    phone: '+101 800 555 45',
    address: '2 Thorndale Circle, Magnolia,de, 19962  United States',
    social: [
      { id: 1, icon: 'fab fa-facebook-f', url: 'https://www.facebook.com' },
      { id: 2, icon: 'fab fa-twitter', url: 'https://twitter.com' },
      { id: 3, icon: 'fab fa-linkedin-in', url: 'https://in.linkedin.com' },
      { id: 4, icon: 'fa-brands fa-github', url: 'https://github.com' },
    ],
    blockquote:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit volup tatem acusantium dolor emque laud antium.',
  },
  {
    id: 5,
    image: teamImg5,
    name: 'Michael Bean',
    position: 'Quality control',
    email: 'info@example.com',
    phone: '+101 800 555 45',
    address: '2 Thorndale Circle, Magnolia,de, 19962  United States',
    social: [
      { id: 1, icon: 'fab fa-facebook-f', url: 'https://www.facebook.com' },
      { id: 2, icon: 'fab fa-twitter', url: 'https://twitter.com' },
      { id: 3, icon: 'fab fa-linkedin-in', url: 'https://in.linkedin.com' },
    ],
    blockquote:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit volup tatem acusantium dolor emque laud antium.',
  },
  {
    id: 6,
    image: teamImg6,
    name: 'Alice Williams',
    position: 'Marketing manager',
    email: 'info@example.com',
    phone: '+101 800 555 45',
    address: '2 Thorndale Circle, Magnolia,de, 19962  United States',
    social: [
      { id: 1, icon: 'fab fa-facebook-f', url: 'https://www.facebook.com' },
      { id: 2, icon: 'fab fa-twitter', url: 'https://twitter.com' },
      { id: 3, icon: 'fab fa-linkedin-in', url: 'https://in.linkedin.com' },
      { id: 4, icon: 'fa-brands fa-dribbble', url: 'https://dribbble.com' },
    ],
    blockquote:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit volup tatem acusantium dolor emque laud antium.',
  },
  {
    id: 7,
    image: teamImg7,
    name: 'Paul Flavius',
    position: 'Human resources',
    email: 'info@example.com',
    phone: '+101 800 555 45',
    address: '2 Thorndale Circle, Magnolia,de, 19962  United States',
    social: [
      { id: 1, icon: 'fab fa-facebook-f', url: 'https://www.facebook.com' },
      { id: 2, icon: 'fab fa-twitter', url: 'https://twitter.com' },
      { id: 3, icon: 'fab fa-linkedin-in', url: 'https://in.linkedin.com' },
    ],
    blockquote:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit volup tatem acusantium dolor emque laud antium.',
  },
  {
    id: 8,
    image: teamImg8,
    name: 'Anne Smith',
    position: 'Sales and Marketing',
    email: 'info@example.com',
    phone: '+101 800 555 45',
    address: '2 Thorndale Circle, Magnolia,de, 19962  United States',
    social: [
      { id: 1, icon: 'fab fa-facebook-f', url: 'https://www.facebook.com' },
      { id: 2, icon: 'fab fa-twitter', url: 'https://twitter.com' },
      { id: 3, icon: 'fab fa-linkedin-in', url: 'https://in.linkedin.com' },
      { id: 4, icon: 'fa-brands fa-dribbble', url: 'https://dribbble.com' },
    ],
    blockquote:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit volup tatem acusantium dolor emque laud antium.',
  },
  {
    id: 9,
    image: teamImg9,
    name: 'Mellissa Doe',
    position: 'Marketing Expert',
    email: 'info@example.com',
    phone: '+101 800 555 45',
    address: '2 Thorndale Circle, Magnolia,de, 19962  United States',
    social: [
      { id: 1, icon: 'fab fa-facebook-f', url: 'https://www.facebook.com' },
      { id: 2, icon: 'fab fa-twitter', url: 'https://twitter.com' },
      { id: 3, icon: 'fab fa-linkedin-in', url: 'https://in.linkedin.com' },
    ],
    blockquote:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit volup tatem acusantium dolor emque laud antium.',
  },
  {
    id: 10,
    image: teamImg10,
    name: 'Ben Aguilar',
    position: 'Community',
    email: 'info@example.com',
    phone: '+101 800 555 45',
    address: '2 Thorndale Circle, Magnolia,de, 19962  United States',
    social: [
      { id: 1, icon: 'fab fa-facebook-f', url: 'https://www.facebook.com' },
      { id: 2, icon: 'fab fa-twitter', url: 'https://twitter.com' },
      { id: 3, icon: 'fab fa-linkedin-in', url: 'https://in.linkedin.com' },
      { id: 4, icon: 'fa-brands fa-dribbble', url: 'https://dribbble.com' },
    ],
    blockquote:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit volup tatem acusantium dolor emque laud antium.',
  },
  {
    id: 11,
    image: teamImg11,
    name: 'Kim Hamilton',
    position: 'Web Developer',
    email: 'info@example.com',
    phone: '+101 800 555 45',
    address: '2 Thorndale Circle, Magnolia,de, 19962  United States',
    social: [
      { id: 1, icon: 'fab fa-facebook-f', url: 'https://www.facebook.com' },
      { id: 2, icon: 'fab fa-twitter', url: 'https://twitter.com' },
      { id: 3, icon: 'fab fa-linkedin-in', url: 'https://in.linkedin.com' },
    ],
    blockquote:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit volup tatem acusantium dolor emque laud antium.',
  },
  {
    id: 12,
    image: teamImg12,
    name: 'Jhon Deo',
    position: 'Web Designer',
    email: 'info@example.com',
    phone: '+101 800 555 45',
    address: '2 Thorndale Circle, Magnolia,de, 19962  United States',
    social: [
      { id: 1, icon: 'fab fa-facebook-f', url: 'https://www.facebook.com' },
      { id: 2, icon: 'fab fa-twitter', url: 'https://twitter.com' },
      { id: 3, icon: 'fab fa-linkedin-in', url: 'https://in.linkedin.com' },
      { id: 4, icon: 'fa-brands fa-skype', url: 'https://www.skype.com'  },
    ],
    blockquote:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit volup tatem acusantium dolor emque laud antium.',
  },
];

export default TeamList;
